import React from "react";

interface CertifiedBadgeProps {
  label?: string;
  type?: string;
}

const CertifiedBadge: React.FC<CertifiedBadgeProps> = ({ label, type }) => {
  let mainClassName = "certified-badge";
  switch (type) {
    case "horizontal":
      mainClassName = "certified-badge-horizontal";
      break;
    case "circle":
      mainClassName = "certificate-icon icon-in-circle-border";
      break;
    case "inactive":
      mainClassName = "certificate-icon icon-in-circle-border no-certificate";
      break;
    default:
      mainClassName = "certified-badge";
  }
  return (
    <div className={mainClassName}>
      <img
        src={
          type === "inactive"
            ? "/images/no_certificate.svg"
            : "/images/certificate.svg"
        }
        width={17}
        height={22}
        alt={`${type === "inactive" && "no"} certificate icon`}
        className={
          type === "horizontal"
            ? "certified-badge-horizontal-img"
            : "simple-icon"
        }
      />
      {label && (
        <span
          className={
            type === "horizontal" ? "certified-badge-horizontal-text" : ""
          }
        >
          {label}
        </span>
      )}
    </div>
  );
};

export default CertifiedBadge;
